
import { geolocationPermissionCheck } from '@/libs/location'
import store from '@/store';

geolocationPermissionCheck().then((position) => {
  store.commit('location/setLocation', position);
});

export default {
  namespaced: true,
  state: {
    location: null,
  },
  actions: {},
  mutations: {
    setLocation(state, location) {
      state.location = location;
    },
  },
  getters: {
    location: state => state.location,
  }
};
